<template>
	<div class="fillInfo" v-loading.fullscreen.lock="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<sub-banner></sub-banner>
		<div class="wrap">
			<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :validate-on-rule-change="false">
				<div class="fillInfo-con">
					<div class="info person">
						<el-row :gutter="0">
							<el-col :sm="6" :xs="24">
								<p class="title">{{$t('fillInfo.title_per')}}</p>
							</el-col>
							<el-col :sm="18" :xs="24">
								<el-row :gutter="gutter">
									<el-col :sm="12" :xs="24">
										<label class="form-title">{{$t('fillInfo.user_cname')}}</label>
										<el-form-item prop="user_cname" >
											<el-input v-model="ruleForm.user_cname" :placeholder="$i18n.locale=='zh'?'请填写您的中文姓名':'請填寫您的中文姓名'" class="form-control-el" maxlength="30"></el-input>
										</el-form-item>
									</el-col>
									<el-col :sm="12" :xs="24">
										<label class="form-title">英文姓名<span>{{$i18n.locale=='zh'?'（选填）':'（選填）'}}</span></label>
										<el-form-item prop="user_ename" >
											<el-input v-model="ruleForm.user_ename" :placeholder="$i18n.locale=='zh'?'请填写您的英文姓名':'請填寫您的英文姓名'" class="form-control-el" maxlength="30"></el-input>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="gutter">
									<el-col :sm="12" :xs="24">
										<label class="form-title">{{$i18n.locale=='zh'?'邮箱':'郵箱'}}<span>{{$i18n.locale=='zh'?'（建议填写EDU邮箱）':'（建議填寫EDU郵箱）'}}</span></label>
										<el-form-item prop="email" >
											<el-input v-model="ruleForm.email" :placeholder="$i18n.locale=='zh'?'请填写您的邮箱':'請填寫您的郵箱'" class="form-control-el" maxlength="50"></el-input>
										</el-form-item>
									</el-col>
									<el-col :sm="12" :xs="24">
										<label class="form-title">{{$t('fillInfo.school_name')}}</label>
										<el-form-item prop="school_name">
											<el-select v-model="ruleForm.school_name" :placeholder="$i18n.locale=='zh'?'请选择':'請選擇'" class="selectBox" >
												<el-option class="selectList" v-for="it in schools" :key="it.id" :label="it.label" :value="it.label" ></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="gutter">
									<el-col :sm="12" :xs="24">
										<label class="form-title">{{$i18n.locale=='zh'?'预计赴港日期':'預計赴港日期'}}<span>{{$i18n.locale=='zh'?'（选填）':'（選填）'}}</span></label>
										<el-form-item prop="reach_date">
										 	<el-date-picker v-model="ruleForm.reach_date" type="date" :placeholder="$i18n.locale=='zh'?'请选择日期':'請選擇日期'" class="form-control-el time" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :editable="false" :picker-options="dateOptions"></el-date-picker>
										</el-form-item>
									</el-col>
									<!-- <el-col :sm="12" :xs="24">
										<label class="form-title">{{$i18n.locale=='zh'?'推荐码':'推薦碼'}}<span>{{$i18n.locale=='zh'?'（选填）领卡后转换校园棒棒糖2019计划即可获取奖励':'（選填）領卡后轉換校園棒棒糖2019計劃即可獲取獎勵'}}</span></label>
										<el-form-item prop="code">
											<el-input v-model="ruleForm.code" :placeholder="$i18n.locale=='zh'?'请填写您的活动推荐码':'請填寫您的活動推薦碼'" class="form-control-el" ></el-input>
											<i class="question">
												<label>
													<p class="top">{{$t('fillInfo.codeDes[0]')}}</p>
													<p class="mrgBt20">{{$t('fillInfo.codeDes[1]')}}</p>
													<p class="top">{{$t('fillInfo.codeDes[2]')}}</p>
													<p>{{$t('fillInfo.codeDes[3]')}}</p>
												</label>
											</i>
										</el-form-item>
									</el-col> -->
								</el-row>
								<el-row :gutter="gutter">
									<el-col :sm="24" :xs="24">
										<label class="form-title" style="margin-bottom: 15px;">{{$i18n.locale=='zh'?'证件上传 ':'證件上傳'}}</label>
										<div class="uploadImg-right">
									  		<p>照片示例</p>
									  		<div class="con">
										  		<img src="../../static/images/uploadImg.jpg"/>
										  		<span><i>{{$i18n.locale=='zh'?'温馨提示：':'溫馨提示：'}}</i><br />{{$t('fillInfo.imgTip')}}</span>
									  		</div>
									  	</div>
										<el-form-item prop="stu_file_name" class="uploadImg" :class="$i18n.locale=='hk'?'hk':''">
										  	<el-upload :before-upload="ImgRules" :on-success="uploadSuccess" :on-progress="uploadProgress" :on-error="uploadErr" action="https://images.ctexcel.com.hk/ctgextrpc/stuActivity/uploadFile" headers="" class="avatar-uploader">
										  		<img v-if="imageUrl" :src="imageUrl"/>
										  		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
										  	</el-upload>
										  	<transition name="el-fade-in-linear">
											  	<div class="progress" v-show = "isProgress">
											  		<el-progress type="circle" :percentage="Number(percentage)" :status="percentage==100?'success':''"></el-progress>
											  	</div>
										  	</transition>
										  	<p> <span>* </span>{{$i18n.locale=='zh'?'格式为：png、jpg、pdf，大小不能超过2M':'格式為：png、jpg、pdf，大小不能超過2M'}}</p>
									  	</el-form-item>
							  		</el-col>
						  		</el-row>
						  	</el-col>
				  		</el-row>
			  		</div>
			  		<div class="info send">
			  			<el-row :gutter="0">
			  				<el-col :sm="6" :xs="24">
				  				<p class="title">{{$t('fillInfo.title_send')}}</p>
				  			</el-col>
				  			<el-col :sm="18" :xs="24">
					  			<el-row :gutter="gutter">
					  				<el-col :sm="12" :xs="24">
					  					<label class="form-title">{{$t('fillInfo.send_address')}}</label>
										<el-form-item  prop="send_address">
											<el-select v-model="ruleForm.send_address" class="selectBox" @change="changeCountry">
												<el-option class="selectList" v-for="it in sends" :key="it.id" :label="it.label" :value="it.value" ></el-option>
											</el-select>
										</el-form-item>
									</el-col>
					  				<el-col :sm="12" :xs="24">
					  					<el-row :gutter="10">
					  						<el-col :sm="8" :xs="8">
					  							<label class="form-title" style="display: block;">{{$t('fillInfo.phone')}}</label>
					  							<el-form-item >
													<el-select v-model="phoneNum" class="selectBox" >
														<el-option class="selectList" v-for="it in phoneTops" :key="it.id" :label="it.value" :value="it.num" >
															<span>{{it.value}}</span>
															<span>{{it.label}}</span>
														</el-option>
													</el-select>
												</el-form-item>
					  						</el-col>
					  						<el-col :sm="16" :xs="16">
					  							<el-form-item prop="phone" :label="$t('fillInfo.phone')" class="phone">
													<el-input v-model="ruleForm.phone" :placeholder="$i18n.locale=='zh'?'请填写您的联系号码':'請填寫您的聯繫電話'" class="form-control-el" maxlength="11"></el-input>
												</el-form-item>	
					  						</el-col>
					  					</el-row>
									</el-col>
					  			</el-row>
					  			<address-ch :deliveryCountry.sync="ruleForm.send_address" :chinaProvince.sync="ruleForm.zone" :chinaCity.sync="ruleForm.district" :chinaArea.sync="ruleForm.area" @change-op="valiField"></address-ch>
					  			<el-row :gutter="gutter">
					  				<el-col :sm="24" :xs="24">
					  					<label class="form-title">{{$t('fillInfo.address')}}</label>
					  					<el-form-item prop="address">
											<el-input v-model="ruleForm.address" :placeholder="$i18n.locale=='zh'?'街号/街名，室，楼，住宅名称':'街號/街名，室，樓，住宅名稱'" class="form-control-el" maxlength="64"></el-input>
										</el-form-item>	
				  					</el-col>
					  			</el-row>
					  			<el-form-item prop="prom_agree" class="agree">
									<el-checkbox v-model="ruleForm.prom_agree" class="form-control-el" true-label="1" false-label="0">{{$t('fillInfo.checkboxs.one')}}</el-checkbox>
								</el-form-item>	
								<el-form-item class="agree">
									<el-checkbox v-model="service_agree" class="form-control-el agree" true-label="1" false-label="0">我同意并接受<a href="javascript: void(0)" @click="serviceShow" style="color: #54b1ff;">{{$i18n.locale=='zh'?'服务条款':'服務條款'}}</a>的所有内容</el-checkbox>
								</el-form-item>	
						  		<p style="text-align: center;"><a href="javascript:void(0)" class="btn_next" @click="next">{{$t('btn.next')}}</a></p>
					  		</el-col>
				  		</el-row>
			  		</div>
		  		</div>
	  		</el-form>
  		</div>
  		<footer>{{$t('footer')}}</footer>
  		<!--信息确认弹窗-->
  		<pop :isPopShow.sync="isShowInfo" cancelBtn_zh="修改" cancelBtn_hk="修改" class="info_confirm" @on-sure="submit" @on-cancel="closePop">
  			<div slot="xw-pop-modal-body" class="xw-pop-modal-body">
	  			<h1>{{$t('fillInfo.pop.title')}}</h1>
	  			<p class="title">{{$t('fillInfo.pop.title_per')}}</p>
	  			<ul>
	  				<li><span>{{$t('fillInfo.user_cname')}}：</span>{{ruleForm.user_cname}}</li>
	  				<li v-if="ruleForm.user_ename"><span>{{$t('fillInfo.user_ename')}}：</span>{{ruleForm.user_ename}}</li>
	  				<li><span>{{$t('fillInfo.email')}}：</span>{{ruleForm.email}}</li>
	  				<li><span>{{$t('fillInfo.school_name')}}：</span>{{ruleForm.school_name}}</li>
	  				<li v-if="ruleForm.reach_date"><span>{{$t('fillInfo.reach_date')}}：</span>{{ruleForm.reach_date}}</li>
	  				<li v-if="ruleForm.code"><span>{{$t('fillInfo.code')}}：</span>{{ruleForm.code}}</li>
	  				<li>{{$i18n.locale=='zh'?'学生文件证件照：已上传':'學生文件證件照：已上傳'}}</li>
	  			</ul>
	  			<p class="title">{{$t('fillInfo.pop.title_send')}}</p>
	  			<ul>
	  				<li><span>{{$t('fillInfo.send_address')}}：</span>{{sends.filter(v => {return v.value == ruleForm.send_address})[0].label}}</li>
	  				<li><span>{{$t('fillInfo.phone')}}：</span>{{phoneNum}}&nbsp;{{ruleForm.phone}}</li>
	  				<li>{{ruleForm.zone}}&nbsp;{{ruleForm.district}}&nbsp;{{ruleForm.area}}&nbsp;{{ruleForm.address}}</li>
	  			</ul>
  			</div>
  		</pop>
  		<!--服务条款弹窗-->
  		<pop class="info_service" :is-pop-show.sync="isShowService" :is-show-cancel="false" sureBtn_zh="确定同意" sureBtn_hk="確定同意" @on-sure="sureService">
  			<div slot="xw-pop-modal-body" class="xw-pop-modal-body">
  				<h1>{{$i18n.locale=='zh'?'客户服务条款':'客戶服務條款'}}</h1>
  				<div class="con">
  					<p v-for="it in $t('fillInfo.service_rule')" v-html="it" :key="it"></p>
  				</div>
  			</div>
  		</pop>
  		<!--提示弹窗-->
  		<pop class="info_warn" :is-pop-show.sync="isShowWarn" :is-show-cancel="false" @on-sure="sureWarn">
  			<div slot="xw-pop-modal-body" class="xw-pop-modal-body">
  				<p>{{$i18n.locale=='zh'?'请仔细阅读条款，并勾选下方的【我已阅读并接受服务条款】框，谢谢~':'請仔細閱讀條款，并勾選下方的【我已閱讀并接受服務條款】框，謝謝~'}}</p>
  			</div>
  		</pop>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import addressCh from '@/components/address'
import subBanner from '@/components/subBanner'
import { submitInfo } from '@/api/api'
import pop from "@/components/pop"
export default {
  name: 'fillInfo',
  components: { addressCh,pop,subBanner },
  data () {
    return {
    	loading: false,
      	imageUrl: '',
      	phoneNum: '852',
      	service_agree: '',
      	percentage: '',//图片上传进度
      	isProgress: false,//图片进度条是否显示
      	isShowInfo: false,//信息确认弹窗
      	isShowService: false,//客户服务条款弹窗
      	isShowWarn: false,//提示弹窗
      	ruleForm: {
	      	user_cname: '',
	      	user_ename: '',
	      	email: '',
	      	school_name: '',
	      	reach_date: '',
	      	code: '',
	      	stu_file_name: '',
	      	phone: '',
	      	send_address: '0',//0是香港，1是大陆
	      	zone: '',
	      	district: '',
	      	area: '',
	      	address: '',
	      	prom_agree: '0',
      	},
      	dateOptions: {
    		disabledDate (time) {
    			let now = new Date()
    			return time.getTime() < now.getTime() - 3600 * 1000 * 24
    		}
    	},
    }
  },
  computed: {
  	...mapState('param',['gutter']),
  	schools () {
    	return [
    		{id: 0,label: this.$i18n.locale=='zh'?'香港大学':'香港大學'},
    		{id: 1,label: this.$i18n.locale=='zh'?'香港科技大学':'香港科技大學'},
    		{id: 2,label: this.$i18n.locale=='zh'?'香港中文大学':'香港中文大學'},
    		{id: 3,label: this.$i18n.locale=='zh'?'香港理工大学':'香港理工大學'},
    		{id: 4,label: this.$i18n.locale=='zh'?'香港浸会大学':'香港浸會大學'},
    		{id: 5,label: this.$i18n.locale=='zh'?'香港城市大学':'香港城市大學'},
    		{id: 6,label: this.$i18n.locale=='zh'?'岭南大学':'嶺南大學'},
    		{id: 7,label: this.$i18n.locale=='zh'?'香港教育学院':'香港教育學院'},
			{id: 8,label: this.$i18n.locale=='zh'?'其他大学院校':'其他大專院校'},
			{id: 9,label: this.$i18n.locale=='zh'?'本港中学':'本港中學'},
			{id: 10,label: this.$i18n.locale=='zh'?'本港小学':'本港小學'},
			{id: 11,label: this.$i18n.locale=='zh'?'其他院校':'其他院校'},
		]
	},
  	errMsg () {
  		return {
  			"1": this.$i18n.locale == 'zh'?"请填写所有信息":"請填寫所有信息",
    		"2": this.$i18n.locale == 'zh'?"该邮箱已申请":"該郵箱已申請",
    		"3": this.$i18n.locale == 'zh'?"该活动推荐码超过使用上限":"該活動推薦碼超過使用上限",
    		"4": this.$i18n.locale == 'zh'?"该活动推荐码不存在":"該活動推薦碼不存在",
    		"5": this.$i18n.locale == 'zh'?"系统繁忙，请稍后再试~":"系統繁忙，請稍後再試~",
    		"6": this.$i18n.locale == 'zh'?"该用户地址已申请":"該用戶地址已申請",
  		}
  	},
  	phoneTops () {
  		return [
  			{id: 0, label: this.$t('countrys.hk'), value: '+852', num: '852' },
  			{id: 1, label: this.$t('countrys.china'), value: '+86', num: '86' },
  		]
  	},
  	sends () {
  		return [
  			{id: 0, label: this.$t('countrys.hk'), value: '0'},
  			{id: 1, label: this.$t('countrys.china'), value: '1'},
  		]
  	},
  	rules () {
  		return {
      		user_cname: [
      			{required: true, message: this.$t('fillInfo.rules.user_cname1'), trigger: ['blur','change'] },
      			{pattern: /^[\u4e00-\u9fa5]{2,30}$/, message: this.$t('fillInfo.rules.user_cname2'), trigger: ['blur','change']},
      		],
      		user_ename: [
      			{pattern: /^[a-zA-Z \s]{2,30}$/, message: this.$t('fillInfo.rules.user_ename'), trigger: ['blur','change']},
      		],
      		school_name: [
      			{required: true, message: this.$t('fillInfo.rules.school_name'), trigger: 'change' },
      		],
      		email: [
      			{required: true, message: this.$t('fillInfo.rules.email1'), trigger: ['blur','change'] },
      			{pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/, message: this.$t('fillInfo.rules.email2'), trigger: ['blur','change']},
      		],
      		code: [
      			{pattern: /^[a-zA-Z0-9]{4}$/, message: this.$t('fillInfo.rules.code'), trigger: ['blur','change']},
      		],
      		stu_file_name: [
      			{required: true, message: this.$t('fillInfo.rules.file_name'), trigger: ['blur','change'] },
      		],
      		phone: [
      			{required: true, message: this.$t('fillInfo.rules.phone1'), trigger: ['blur','change'] },
      			{pattern: /^[0-9\+\-]+$/, message: this.$t('fillInfo.rules.phone2'), trigger: ['blur','change']},
      		],
      		zone: [
      			{required: true, message: this.ruleForm.send_address=='1'?this.$t('fillInfo.rules.zone1'):this.$t('fillInfo.rules.zone2'), trigger: 'change' },
      		],
      		district: [
      			{required: true, message: this.ruleForm.send_address=='1'?this.$t('fillInfo.rules.district1'):this.$t('fillInfo.rules.district2'), trigger: 'change' },
      		],
      		area: [
      			{required: true, message: this.$t('fillInfo.rules.area'), trigger: 'change' },
      		],
      		address: [
      			{required: true, message: this.$t('fillInfo.rules.address1'), trigger: ['blur','change'] },
      			{pattern: /^[0-9\+\-a-zA-Z\u4e00-\u9fa5\s,，/—]{1,64}$/, message: this.$t('fillInfo.rules.address2'), trigger: ['blur','change']},
      		],
      	}
  	},
  },
  methods: {
  	ImgRules (file) {//图片上传限制规则
  		console.log(file)
  		const isFormat = (file.type === 'image/jpeg'||file.type === 'image/png'||file.type === 'application/pdf')
  		if(!isFormat){
  			this.$message.error(this.$i18n.locale=='zh'?'请重新上传符合要求的证明文件':'請重新上傳符合要求的證明文件');
  		}
  		const isLt2M = file.size / 1024 / 1024 < 2;
  		if(!isLt2M){
  			this.$message.error(this.$i18n.locale=='zh'?'上传图片大小不能超过 2MB!':'上傳圖片大小不能超過 2MB!');
  		}
  		return isFormat && isLt2M;
  	},
  	uploadSuccess (res, file) {//图片上传成功
  		console.log(res)
  		console.log(file)
  		this.percentage = 100
  		setTimeout(() => {
  			//让进度条消失
  			this.isProgress = false
  		},500)
  		//赋值传回给后台
  		this.ruleForm.stu_file_name = res.file_name
  		//让图片显示出来
  		this.imageUrl = URL.createObjectURL(file.raw);
  		if(file.raw.type === 'application/pdf'){
  			this.imageUrl = require('../../static/images/imguploadSuccess_hk.jpg')
  		}
  		//及时验证
  		this.$refs.ruleForm.validateField('stu_file_name')
  	},
  	uploadProgress (event) {//图片上传过程中
  		//console.log(event)
  		this.isProgress = true//进度条显示
  		//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
  		if(event.lengthComputable){//如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
  			this.$nextTick(() => {//实时更新数据
  				this.percentage = parseInt(event.percent - 10)
  			})
  		}
  	},
  	uploadErr () {//图片上传失败
  		this.isProgress = false//进度条隐藏
  		this.$alert(this.$i18n.locale=='zh'?'图片上传失败，请稍后重试~':'圖片上傳失敗，請稍後重試~', '提示', {
  			confirmButtonText: this.$t('btn.sure'),
  		})
  	},
  	valiField () {//实时改变addressCh三级联动时，父组件实时执行表单校验
  		if(this.ruleForm.district){
  			this.$refs.ruleForm.validateField('district')
  		}
  		if(this.ruleForm.area){
  			this.$refs.ruleForm.validateField('area')
  		}
  	},
  	changeCountry () {//改变寄送地址
  		//清空zone district area(三级联动)
  		this.ruleForm.zone = ''
  		this.ruleForm.district = ''
  		this.ruleForm.area = ''
  		//联系电话联动变化
  		this.phoneNum = this.phoneTops.filter(v => {return v.id == this.ruleForm.send_address})[0].num
  	},
  	closePop () {//关闭确认信息弹窗
  		this.isShowInfo = false
  	},
  	serviceShow() {//点击弹出服务条款
  		//let serFlag = window.sessionStorage.getItem('serFlag')
  		this.isShowService = true
  	},
  	sureService () {//确定条款
  		//window.sessionStorage.setItem('serFlag','1')
  		this.isShowService = false
  		//确定复选框勾上
  		this.service_agree = '1'
  	},
  	sureWarn () {//点击提示框确认按钮，关闭弹窗
  		this.isShowWarn = false
  	},
  	next () {
  		this.$refs.ruleForm.validate((valid) => {
  			if(valid){
  				//验证通过
  				//判断是否勾选同意条款
  				if(this.service_agree != '1'){
  					//如果没勾选，弹出提示
  					this.isShowWarn = true
  				}else{
  					//弹出信息确认弹窗
  					this.isShowInfo = true
  				}
  			}
  		})
  	},
  	submit () {
  		//向后台提交数据
		let params = {}
		for(let key in this.ruleForm){
			if(key === 'phone'){
				params.phone = this.phoneNum + " " + this.ruleForm.phone
			}else{
				params[key] = this.ruleForm[key]
			}
		}
		params.lang = this.$i18n.locale
		console.log(params)
		this.loading = true
		submitInfo(params)
		.then( res => {
			this.loading = false
			console.log(res)
			if( res.code == "0" ){
				//跳转到领卡成功页面
				this.$store.commit('param/setOrderId', res.order_id)
				window.sessionStorage.setItem('order_id', res.order_id)
				//window.sessionStorage.setItem('serFlag','0')//标识服务条款
				this.$router.push({name: 'getCardSuccess'});
			}else{
				this.$alert(this.errMsg[res.code], '提示', {
		  			confirmButtonText: this.$t('btn.sure'),
		  		})
			}
		})
		.catch( err => {
			this.loading = true
			console.log(err)
		})
  	}
  },
  created () {
  	//如果直接进信息填写页面 默认 活动标识为 线上 online
  	window.sessionStorage.setItem('activeFlag', 'online')
  	this.$store.commit('param/setActiveFlag', sessionStorage.getItem('activeFlag'))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.form-title{
	font-size: 14px;
	line-height: 14px;
    margin-bottom: 6px;
    color: #4e4e4e;
    display: inline-block;
    i{
    	margin-right: 5px;
    	color: #f56c6c;
    }
    span{
    	font-size: 12px;
    	color: #9f9f9f;
    	line-height: 12px;
    }
}
.uploadImg{
	.avatar-uploader{
		width: 298px;
		height: 134px;
		border: 1px solid #dcdcdc;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #f7fdff;
		.avatar-uploader-icon {
			width: 298px;
		    height: 134px;
		    background: url(../../static/images/z-upload-zj_hk-s.png) no-repeat center;
		}
		.el-icon-plus:before{
			content: none;
		}
		img{
			width: 100%;
		  	display: block;
	 	}
	}
	.progress{
		border-radius: 6px;
		background: #fff;
		width: 100%;
		height: 100%;
		text-align: center;
		position: absolute;
		top: 1px;
		left: 1px;
		line-height: 134px;
	}
	p{
		font-size: 12px;
		line-height: 12px;
		margin-top: 6px;
		span{
			color: #ff0000;
		}
	}
}
.uploadImg.hk{
	.avatar-uploader{
		.avatar-uploader-icon {
			 background: url(../../static/images/z-upload-zj_hk.png) no-repeat center;
		}
	}
}
.uploadImg-right{
	width: 300px;
	float: right;
	p{
		font-size: 14px;
		color: #999;
		margin-bottom: 8px;
	}
	p:after{
		content: "";
		display: inline-block;
		width: 238px;
		height: 0;
		border-top: 1px dashed #999;
		vertical-align: middle;
		margin-left: 5px;
	}
	.con{
		display: flex;
		align-items: flex-end;
		span{
			font-size: 12px;
			color: #666;
			padding-left: 10px;
			i{
				font-style: normal;
				padding-left: 18px;
				font-weight: 700;
				position: relative;
			}
			i:before{
				content: '';
				display: inline-block;
				width: 13px;
				height: 11px;
				background: url(../../static/images/heart-icon.png) no-repeat;
				position: absolute;
				left: 0;
				top: 1px;
			}
		}
	}
}
.fillInfo-con{
	.title{
		font-size: 18px;
	    line-height: 19px;
	    padding-left: 12px;
	    color: #393838;
	    border-left: 3px solid #0842ad;
	}
	.info{
		padding-top: 25px;
	}
	.send{
		margin-top: 25px;
	}
	.btn_next{
		display: inline-block;
	    box-sizing: border-box;
	    height: 50px;
	    text-decoration: none;
	    line-height: 50px;
	    font-size: 16px;
	    text-align: center;
	    padding: 0 56px;
	    color: #fff;
	    background: #f96e4c;
	    border-radius: 5px;
	    margin-top: 35px;
	    margin-bottom: 40px;
        background-image: linear-gradient(180deg, rgb(250,118,79) 0%, rgb(243,75,63) 100%);
	}
}
footer{
	text-align: center;
	line-height: 55px;
	font-size: 12px;
	color: #999;
}
.agree{
	margin-bottom: 10px;
}
@media (min-width:768px) {
	.fillInfo{
		.wrap{
			box-sizing: border-box;
			width: 1000px;
			margin: 0 auto;
			padding-left: 64px;
			padding-right: 80px;
		}
	}
}
@media (max-width:767px) {
	.fillInfo{
		.wrap{
			padding: 0 20px;
		}
		.title{
			margin-bottom: 15px;
		}
		.send{
			margin-top: 0;
		}
	}
	.uploadImg{
		padding-bottom: 165px;
	}
	.uploadImg-right{
		float: none;
		position: absolute;
		bottom: 0;
	}
}
</style>




// WEBPACK FOOTER //
// src/pages/fillInfo.vue